import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const inboundTaskDetailRBAC = {
  pageID: '141c381030a3cf2c94bb5886739004a8',
  elementID: {
    ViewDetail: '37e9a36595cc8fd43405d665e01dc988',
  },
} as const

export const useRBACInboundTaskDetailPage = createUseRBAC(inboundTaskDetailRBAC.elementID)

export type UseRBACInboundTaskDetailPageType = ReturnType<typeof useRBACInboundTaskDetailPage>
